<template>
  <div class="page">
    <nav-bar />
    <div class="page-ready">
      <div class="page-ready__wrapper">
        <img
          src="../assets/img/cracker.png"
          alt="Поздравляем!"
          class="page-ready__img"
        />
        <h1 class="page-ready__title">
          Поздравляем!<br />Ваша страница готова!
        </h1>

        <div class="page-ready__link">
          <label class="page-ready__label" for="page-link"
            >Ссылка на вашу страницу:</label
          >
          <div class="page-ready__link-address">
            <CTooltip :action="show_tooltip" :position="tooltip_position">{{
              tooltip
            }}</CTooltip>
            <input
              class="page-ready__input"
              type="text"
              id="page-link"
              readonly
              :value="`${amwayLink}/${user.abo_number}`"
            />
            <button
              class="page-ready__copy-btn"
              @click="copyToClipboard('page-ready__input')"
            >
              Копировать
            </button>
          </div>
        </div>

        <div class="page-ready__social">
          <p class="page-ready__text">
            Это отличная новость для друзей и партнеров! Поделитесь ей в
            социальных сетях:
          </p>
          <div class="page-ready__icons">
            <a
              class="page-ready__icon-btn"
              :href="
                `http://vk.com/share.php?url=${amwayLink}/${user.abo_number}`
              "
              @click="
                this.GAEvent(
                  'success-reg_social',
                  'social_link',
                  `http://vk.com/share.php?url=${amwayLink}/${user.abo_number}`
                )
              "
              target="_blank"
              ><img src="../assets/img/icon-vk.svg" alt="ВК"
            /></a>
            <a
              class="page-ready__icon-btn"
              :href="
                `http://www.facebook.com/sharer/sharer.php?s=100&p%5Btitle%5D=AmwayPersonalPage&p%5Burl%5D=${amwayLink}/${user.abo_number}`
              "
              @click="
                this.GAEvent(
                  'success-reg_social',
                  'social_link',
                  `http://www.facebook.com/sharer/sharer.php?s=100&p%5Btitle%5D=AmwayPersonalPage&p%5Burl%5D=${amwayLink}/${user.abo_number}`
                )
              "
              target="_blank"
              ><img src="../assets/img/icon-fb.svg" alt="FB"
            /></a>
            <a
              class="page-ready__icon-btn"
              :href="
                `https://twitter.com/share?url=${amwayLink}/${user.abo_number}`
              "
              @click="
                this.GAEvent(
                  'success-reg_social',
                  'social_link',
                  `https://twitter.com/share?url=${amwayLink}/${user.abo_number}`
                )
              "
              ><img src="../assets/img/icon-twitter.svg" alt="Twitter"
            /></a>
            <a
              class="page-ready__icon-btn"
              :href="
                `http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1&st._surl=${amwayLink}/${user.abo_number}`
              "
              @click="
                this.GAEvent(
                  'success-reg_social',
                  'social_link',
                  `http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1&st._surl=${amwayLink}/${user.abo_number}`
                )
              "
              ><img
                src="../assets/img/icon-odnoklasniki.svg"
                alt="Odnoklassniki"
            /></a>
          </div>
        </div>

        <div class="page-ready__buttons">
          <button class="pBtn pBtn--blue" @click="$router.push('/')">
            Управление страницей
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CTooltip from "../components/forms/CTooltip";

export default {
  name: "ReadyPage",
  components: { CTooltip },
  data() {
    return {
      show_tooltip: true,
      tooltip_position: "left",
      tooltip:
        "Скоро ваша Личная страница появится на сайте amway.ru. Пока она доступна по отдельной ссылке."
    };
  },
  computed: {
    ...mapState(["user", "page"]),
    ...mapGetters(["getComponentByName"]),
    amwayLink() {
      return window.location.host.match(/^kz/)
        ? process.env.VUE_APP_PAGE_KZ
        : process.env.VUE_APP_PAGE;
    }
  },
  methods: {
    copyToClipboard: function(element) {
      let inputBlock = document.querySelector("." + element);
      const el = document.createElement("textarea");
      el.value = inputBlock.value;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$eventBus.$emit("serverSyncSuccess", {
        msg: "Ссылка скопирована"
      });
      this.show_tooltip = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
@import "@/assets/scss/global.scss";

.page {
  background: #3479cc;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  @media #{$tablet} {
    padding: 0;
  }
}

.page-ready {
  background: #ffffff;
  border-radius: 10px;
  margin-top: 30px;
  padding: 90px 0;
  display: flex;
  justify-content: center;
  max-width: 1200px;
  width: 100%;
  text-align: center;
  @media #{$tablet} {
    min-height: 100vh;
    border-radius: 0;
    padding: 150px 0;
  }
  @media #{$mobile} {
    padding: 45px 15px;
  }

  &__wrapper {
    width: 587px;

    @media #{$tablet} {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
    }

    @media #{$mobile} {
      width: 90%;
    }
  }

  &__img {
    margin-bottom: 30px;
    max-width: 120px;
    @media #{$tablet} {
      margin: 0;
    }
    @media #{$mobile} {
      max-width: 100px;
    }
  }

  &__title {
    padding: 0;
    margin: 0 0 40px;
    font-weight: bold;
    font-size: 48px;
    @media #{$tablet} {
      max-width: 100%;
    }
    @media #{$mobile} {
      font-size: 34px;
      line-height: 44px;
    }
  }

  &__link {
    width: 100%;
    margin-bottom: 60px;

    text-align: left;
  }

  &__link-address {
    position: relative;
    display: flex;
    justify-content: space-between;

    margin-top: 5px;

    @media #{$mobile} {
      flex-direction: column;
      align-items: center;
    }
  }

  &__input {
    width: 390px;
    height: 45px;
    padding-left: 15px;

    font-size: 16px;
    line-height: 22px;

    border: 1px solid #e0e0e0;
    border-radius: 5px;

    @media #{$mobile} {
      width: 100%;
      margin-bottom: 22px;
    }
  }

  &__copy-btn {
    position: relative;

    width: 162px;
    padding: 0;
    padding-left: 33px;

    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    text-transform: uppercase;

    background-color: transparent;
    border: none;
    cursor: pointer;
  }

  &__copy-btn::before {
    content: "";

    position: absolute;
    left: 0;
    top: 50%;

    width: 22px;
    height: 24px;

    background-image: url("../assets/img/copy-black.svg");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;

    transform: translateY(-50%);
  }

  &__social {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 80px;

    @media #{$mobile} {
      flex-direction: column;
      align-items: center;
      margin-bottom: 60px;
    }
  }

  &__text {
    width: 379px;
    margin: 0;

    text-align: left;

    @media #{$mobile} {
      width: 100%;
      margin-bottom: 15px;
    }
  }

  &__icons {
    display: flex;
    justify-content: space-between;
    width: 186px;
  }

  &__icon-btn {
    width: 36px;
    height: 36px;
    padding: 0;

    text-decoration: none;
  }

  &__buttons {
    & > * {
      margin: 0 15px;
      @media #{$mobile} {
        margin: 8px 0;
        width: 100%;
      }
    }
  }
}
</style>
